import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeAutresInfosATTR } from '../models/TypeAutresInfosATTR';
import { Step6 } from '../../../../shared/models/component-messages/diveAT/step6';

@Component({
  selector: 'app-type-autres-infosATTR',
  templateUrl: './type-autres-infosATTR.component.html'
})
export class TypeAutresInfosATTRComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeAutresInfosATTR';
  @Input() parentForm: FormGroup;
  @Input() autresInformations: TypeAutresInfosATTR;
  @Input() disabled: boolean;

  public step6 = new Step6();

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
